import React from 'react';
import { Helmet } from 'react-helmet';
import LoginForm from './components/LoginForm';
import LoginBenefits from './components/LoginBenefits';

const UserLogin = () => {
  return (
    <>
      <Helmet>
        <title>Sign In - Smart Cities Onboarding Platform</title>
        <meta name="description" content="Sign in to your Smart Cities account to collaborate on urban innovation projects, access learning pathways, and connect with city officials and student teams." />
        <meta name="keywords" content="smart cities, login, urban innovation, student collaboration, city officials" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Content */}
        <div className="flex min-h-screen">
          {/* Left Side - Benefits (Hidden on mobile) */}
          <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary/5 to-accent/5 p-12 items-center">
            <div className="w-full max-w-lg mx-auto">
              <LoginBenefits />
            </div>
          </div>

          {/* Right Side - Login Form */}
          <div className="flex-1 lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
            <div className="w-full max-w-md space-y-8">
              <LoginForm />
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-card border-t border-border py-6">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 bg-primary rounded flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-foreground">SC</span>
                </div>
                <span className="text-sm text-muted-foreground">
                  © {new Date()?.getFullYear()} Smart Cities Onboarding Platform. All rights reserved.
                </span>
              </div>
              
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <a href="#" className="hover:text-foreground transition-micro">Support</a>
                <a href="#" className="hover:text-foreground transition-micro">Privacy</a>
                <a href="#" className="hover:text-foreground transition-micro">Terms</a>
                <a href="#" className="hover:text-foreground transition-micro">Accessibility</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default UserLogin;